import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { utils, EventObserver, useKeyPress } from '@costar/theme-ui';
import React, { useMemo, useState, useRef, useEffect, useContext } from 'react';
import { optionsToArray } from './utils.esm.js';

/**
 * @ignore - internal component.
 */
var Context = /*#__PURE__*/React.createContext({});
if (process.env.NODE_ENV !== 'production') {
  Context.displayName = 'SelectKeyNavContext';
}
var SelectKeyNavContextProvider = function SelectKeyNavContextProvider(props) {
  var _props$selectionClick = props.selectionClick,
    selectionClick = _props$selectionClick === void 0 ? function (_v) {
      return utils.noop;
    } : _props$selectionClick,
    _props$handleClose = props.handleClose,
    handleClose = _props$handleClose === void 0 ? utils.noop : _props$handleClose,
    options = props.options,
    isMultiSelect = props.isMultiSelect,
    horizontalNav = props.horizontalNav,
    children = props.children;
  var context = useMemo(function () {
    return {
      hoverEventObserver: new EventObserver('key-nav-hoverEvent')
    };
  }, []);
  var hoverEventObserver = context.hoverEventObserver;
  var _useKeyPress = useKeyPress(horizontalNav ? 'ArrowRight' : 'ArrowDown'),
    _useKeyPress2 = _slicedToArray(_useKeyPress, 1),
    downPress = _useKeyPress2[0];
  var _useKeyPress3 = useKeyPress(horizontalNav ? 'ArrowLeft' : 'ArrowUp'),
    _useKeyPress4 = _slicedToArray(_useKeyPress3, 1),
    upPress = _useKeyPress4[0];
  var _useKeyPress5 = useKeyPress('Enter'),
    _useKeyPress6 = _slicedToArray(_useKeyPress5, 1),
    enterPress = _useKeyPress6[0];
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    cursor = _useState2[0],
    setCursor = _useState2[1];
  var optionsRef = useRef(undefined);
  useEffect(function () {
    optionsRef.current = optionsToArray(options);
    setCursor(0);
  }, [options]);
  useEffect(function () {
    var handelMouseHover = function handelMouseHover(key) {
      var _options = optionsRef.current;
      if (Array.isArray(_options) && _options.length) {
        setCursor(_options.indexOf(key));
      }
    };
    hoverEventObserver === null || hoverEventObserver === void 0 ? void 0 : hoverEventObserver.attach(handelMouseHover);
    return function () {
      return hoverEventObserver === null || hoverEventObserver === void 0 ? void 0 : hoverEventObserver.detach(handelMouseHover);
    };
  }, [hoverEventObserver]);
  useEffect(function () {
    var _options = optionsRef.current;
    if (Array.isArray(_options) && _options.length) {
      if (downPress) {
        setCursor(function (prevState) {
          return prevState < _options.length - 1 ? prevState + 1 : prevState;
        });
      }
    }
  }, [downPress]);
  useEffect(function () {
    var _options = optionsRef.current;
    if (Array.isArray(_options) && _options.length) {
      if (upPress) {
        setCursor(function (prevState) {
          return prevState > 0 ? prevState - 1 : prevState;
        });
      }
    }
  }, [upPress]);
  useEffect(function () {
    var _options = optionsRef.current;
    if (Array.isArray(_options) && _options.length) {
      var nextActive = _options[cursor];
      if (nextActive) {
        if (enterPress) {
          selectionClick(nextActive)();
          if (!isMultiSelect) {
            handleClose();
          }
        } else {
          hoverEventObserver === null || hoverEventObserver === void 0 ? void 0 : hoverEventObserver.notify(nextActive);
        }
      }
    }
  }, [cursor, enterPress, handleClose, hoverEventObserver, selectionClick, isMultiSelect]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: context
  }, children);
};
var useSelectKeyNavContext = function useSelectKeyNavContext() {
  return useContext(Context);
};

export { SelectKeyNavContextProvider, useSelectKeyNavContext };
//# sourceMappingURL=select-key-nav-context.esm.js.map
